import { createContext, useContext, type ReactNode } from "react";

interface FormDisplay {
    /** Hide the red asterisk on required questions. The question stays required. */
    hideRequiredMarker: boolean;
}

const FormDisplayContext = createContext<FormDisplay>({ hideRequiredMarker: false });

/** Per-form display switches (forms.show_required_marker) for the questions inside it. */
export function FormDisplayProvider({ hideRequiredMarker, children }: FormDisplay & { children: ReactNode }) {
    return <FormDisplayContext.Provider value={{ hideRequiredMarker }}>{children}</FormDisplayContext.Provider>;
}

/** The red asterisk after a required question label. Hidden when the form turns it off. */
export function RequiredMark() {
    const { hideRequiredMarker } = useContext(FormDisplayContext);
    if (hideRequiredMarker) return null;
    return <span className="ml-0.5 text-red-500">*</span>;
}
